export const QuotationValidation = (formData) => {
    const errors = {};
    debugger;
    if (formData.formData.type.toString() === "1" && formData.formData.ClientType.toString() === "0") {
        if (!formData.formData.CustomerID || formData.formData.CustomerID === "0") {
            errors.CustomerID = 'This field is required';
        }

        if (!formData.formData.FK_ClientBranch_ID || formData.formData.FK_ClientBranch_ID === "0") {
            errors.FK_ClientBranch_ID = 'This field is required';
        }
        if (!formData.formData.FK_ClientContact_ID || formData.formData.FK_ClientContact_ID === "0") {
            errors.FK_ClientContact_ID = 'This field is required';
        }
    }
    if (!formData.formData.dt_QuotationDate.trim()) {
        errors.dt_QuotationDate = 'This field is required';
    }
    if (!formData.formData.FK_QuotationStatus_ID || formData.formData.FK_QuotationStatus_ID == "0") {
        errors.FK_QuotationStatus_ID = 'This field is required';
    }




    return errors;
};
